export const getStepByPosition = (formJSON, index) => {
	return formJSON[index];
	// return formJSON?.find((item) => item.stepPosition === position);
};
